'use strict';
var parent = require('../../stable/map');
require('../../modules/esnext.map.group-by');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/actual/map/index.js
// module id = 1224
// module chunks = 0